import React from 'react';
import { css } from 'styled-components';
import PersonInfo from 'components/common/PersonInfo';
import { dateFormat, nl2 } from 'util/filters';
import i18n from 'i18n';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Image from 'components/common/Image';
import icBtnUpPC1x from 'assets/images/PC/@1x/ic_btn_up.png';
import icBtnUpPC2x from 'assets/images/PC/@2x/ic_btn_up@2x.png';
import icBtnUpSP2x from 'assets/images/SP/@2x/ic_btn_up2@2x.png';
import icBtnUpSP3x from 'assets/images/SP/@3x/ic_btn_up2@3x.png';
import icBtnDownPC1x from 'assets/images/PC/@1x/ic_btn_down.png';
import icBtnDownPC2x from 'assets/images/PC/@2x/ic_btn_down@2x.png';
import icBtnDownSP2x from 'assets/images/SP/@2x/ic_btn_down2@2x.png';
import icBtnDownSP3x from 'assets/images/SP/@3x/ic_btn_down2@3x.png';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import SubHeading from 'components/common/SubHeading';
import Button from 'components/common/Button';
import icDatePC1x from 'assets/images/PC/@1x/ic_date.png';
import icDatePC2x from 'assets/images/PC/@2x/ic_date@2x.png';
import icDateSP2x from 'assets/images/SP/@2x/ic_date@2x.png';
import icDateSP3x from 'assets/images/SP/@3x/ic_date@3x.png';
import moment from 'moment-timezone';
import { PreferredTimeOptions } from 'constants/preferred-delivery-time';

class Delivery extends React.Component {
  constructor() {
    super();
    this.state = {
      opened: false
    };
  }

  componentDidMount() {
    this.setState({
      opened: !!this.props.opened
    });
  }

  formatWrappingInfo = wrappingInfo => (
    <React.Fragment>
      <p>{wrappingInfo.wrappingType}</p>
      {wrappingInfo.wrappingType !== i18n.t('mypage:wrappingTypeNoName') && (
        <p className="wrapping-info">
          <span className="wrapping-info-label">
            <span className="content-label">
              {i18n.t('mypage:wrappingInfoLabel')}
            </span>
            <span> : </span>
          </span>
          <span>
            <span>
              {i18n.t('common:inscriptionLabel')}{' '}
              {wrappingInfo.inscription || i18n.t('common:none')}{' '}
              {i18n.t('common:shipperNameLabel')}{' '}
              {wrappingInfo.shipperName || i18n.t('common:none')}
            </span>
          </span>
        </p>
      )}
    </React.Fragment>
  );

  handleClickToggle = () => {
    this.setState({
      opened: !this.state.opened
    });
  };

  handleClickTrackButton = trackingNumber => {
    window.open(
      `https://trackings.post.japanpost.jp/services/srv/search/?requestNo1=${trackingNumber}&requestNo2=&requestNo3=&requestNo4=&requestNo5=&requestNo6=&requestNo7=&requestNo8=&requestNo9=&requestNo10=&search.x=86&search.y=17&startingUrlPatten=&locale=ja`,
      '_blank'
    );
  };

  formatScheduledOn = scheduledOn =>
    scheduledOn
      ? dateFormat(scheduledOn, i18n.t('common:dateFormat.dateName'))
      : i18n.t('mypage:notYetScheduled');

  formatScheduledOnTime = scheduledOn => {
    if (!scheduledOn) {
      return i18n.t('mypage:notYetScheduled');
    }

    const time = +moment.tz(scheduledOn, 'Asia/Tokyo').format('HH');
    const scheduledOnTime = PreferredTimeOptions.find(
      item => item.value === time
    );
    return time ? scheduledOnTime.label : i18n.t('mypage:notYetScheduled');
  };

  render() {
    const {
      className,
      index,
      receiverName,
      receiverNameKana,
      receiverPostcode,
      receiverAddress,
      receiverTelephone,
      trackingNumber,
      scheduledOn,
      shipperName,
      shipperNameKana,
      shipperPostcode,
      shipperAddress,
      shipperTelephone,
      wrappingInfo,
      messageCard,
      num,
      validatedOn,
      expiredOn
    } = this.props;

    const { opened } = this.state;

    return (
      <div className={className}>
        <div className="delivery">
          <button
            type="button"
            className="btn-toggle"
            onClick={() => this.handleClickToggle()}
          >
            {opened ? (
              <Image
                pc1x={icBtnUpPC1x}
                pc2x={icBtnUpPC2x}
                sp2x={icBtnUpSP2x}
                sp3x={icBtnUpSP3x}
                alt="ic_btn_up"
              />
            ) : (
              <Image
                pc1x={icBtnDownPC1x}
                pc2x={icBtnDownPC2x}
                sp2x={icBtnDownSP2x}
                sp3x={icBtnDownSP3x}
                alt="ic_btn_down"
              />
            )}
          </button>
          <div className="header">
            <div className="header-title">
              <h4 className="title">
                {i18n.t('mypage:destination')}
                {index}
              </h4>
              <div className="scheduledOn">
                <p>
                  <span className="content-label">
                    {i18n.t('mypage:scheduledOn')}
                  </span>
                  <span> : </span>
                  <span>{this.formatScheduledOn(scheduledOn)}</span>
                </p>
                <p>
                  <span className="content-label">
                    {i18n.t('mypage:scheduledOnTime')}
                  </span>
                  <span> : </span>
                  <span>{this.formatScheduledOnTime(scheduledOn)}</span>
                </p>
              </div>
            </div>
            <div className="header-container">
              <div>
                <div className="item-info">
                  <p className="num">
                    <span className="content-label">
                      {i18n.t('mypage:itemNumber')} :{' '}
                    </span>
                    {num}
                    {i18n.t('common:sheet')}
                  </p>
                  <div className="expires">
                    <span className="content-label">
                      {i18n.t('mypage:expires')} :{' '}
                    </span>
                    <p>
                      <span className="start-date">
                        {moment.tz(validatedOn, 'Asia/Tokyo').format(
                          i18n.t('common:dateFormat.dateName')
                        )}
                      </span>
                      <Image
                        pc1x={icDatePC1x}
                        pc2x={icDatePC2x}
                        sp2x={icDateSP2x}
                        sp3x={icDateSP3x}
                        alt="ic_date"
                      />
                      <span className="end-date">
                        {moment.tz(expiredOn, 'Asia/Tokyo').format(
                          i18n.t('common:dateFormat.dateName')
                        )}
                      </span>
                    </p>
                  </div>
                </div>
                <SubHeading>{i18n.t('mypage:receiver')}</SubHeading>

                <PersonInfo
                  name={receiverName}
                  nameKana={receiverNameKana}
                  postcode={receiverPostcode}
                  address={receiverAddress}
                  tel={receiverTelephone}
                />
              </div>
              {trackingNumber !== '' && (
                <div className="column-extra">
                  <p>
                    <span className="content-label">
                      {i18n.t('mypage:trackingNumber')} :{' '}
                    </span>
                    {trackingNumber}
                  </p>
                  <Button
                    type="button"
                    buttonType="F"
                    onClick={() => this.handleClickTrackButton(trackingNumber)}
                  >
                    {i18n.t('mypage:deliveryInfo')}
                  </Button>
                </div>
              )}
            </div>
          </div>
          <div className={`body ${opened ? 'open' : 'close'}`}>
            <ul className="delivery-detail">
              <li>
                <SubHeading>{i18n.t('mypage:client')}</SubHeading>
                <div className="client">
                  <PersonInfo
                    name={shipperName}
                    nameKana={shipperNameKana}
                    postcode={shipperPostcode}
                    address={shipperAddress}
                    tel={shipperTelephone}
                  />
                </div>
              </li>
              <li className="inscription">
                <SubHeading>{i18n.t('mypage:inscription')}</SubHeading>
                {this.formatWrappingInfo(wrappingInfo)}
              </li>
              <li className="message-card">
                <SubHeading>{i18n.t('mypage:messageCard')}</SubHeading>
                <p>{nl2(messageCard) || i18n.t('common:none')}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

const commonStyle = css`
  .delivery {
    position: relative;
    width: 100%;
    border: 1px solid ${Colors.gray2};

    .btn-toggle {
      position: absolute;
    }
  }

  .btn-toggle {
    padding: 0;
    margin-right: 16px;
    background-color: transparent;
    border: 0;
    outline: none;
    appearance: none;
  }

  .header {
    .header-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: ${Colors.black1};
      border-bottom: 1px dotted ${Colors.gray2};

      .title {
        margin: 0;
      }

      .scheduledOn {
        p {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0;

          .content-label {
            margin-right: 6px;

            & + span {
              flex-grow: 1;
              margin-right: 6px;
            }
          }
        }
      }
    }

    .header-container {
      .item-info {
        p {
          margin: 0;
        }
      }
      .column-extra {
        p {
          margin: 0;
        }
        ${Button} {
          margin-top: 8px;
        }
      }
    }
  }

  .body {
    overflow: hidden;
    transition: max-height 0.5s ease;

    &.close {
      max-height: 0;
    }

    .inscription,
    .message-card {
      p {
        margin: 0;
      }
    }

    .inscription {
      .wrapping-info {
        display: flex;

        .wrapping-info-label {
          min-width: 80px;
        }
      }
    }
  }

  .delivery-detail {
    padding: 0;
    list-style: none;
  }

  .message-card {
    white-space: pre-wrap;
  }

  .expires {
    display: flex;

    .content-label {
      display: block;
      flex-shrink: 0;
      margin-right: 4px;
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  width: 100%;

  .delivery {
    padding: 0 16px 40px 72px;

    .btn-toggle {
      top: 155px;
      left: 16px;
    }

    .header {
      ${SubHeading} {
        margin: 16px 0 8px;
      }

      .header-title {
        padding: 18px 0;
        .title {
          ${FontStyles.text3};
        }
      }

      .header-container {
        display: flex;
        justify-content: space-between;
        margin-top: 19px;

        .item-info {
          .expires {
            margin-top: 3px;

            picture {
              margin: 0 5px;

              img {
                vertical-align: bottom;
              }
            }
          }
        }

        ${SubHeading} {
          margin-bottom: 11px;
        }

        .column-extra {
          text-align: right;
        }
      }
    }

    .body {
      &.open {
        max-height: 1260px;
      }
    }
  }

  .delivery-detail {
    padding-top: 40px;
    margin: 19px 0 0;
    border-top: 1px solid ${Colors.gray3};

    ${SubHeading} {
      margin-bottom: 11px;
    }

    li {
      margin-bottom: 35px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .content-label {
    ${FontStyles.text8};
  }

`;

const spStyle = CustomMedia.lessThan('medium')`
  ${SubHeading} {
    margin-bottom: 12px;
    ${FontStyles.text5};
  }

  .delivery {
    .btn-toggle {
      bottom: -22px;
      left: 50%;
      transform: translate(-50%, 0);
      background-color: ${Colors.white1};
    }

    .header {
      margin: 0px 16px 40px;

      .header-title {
        padding: 12px 0;
        .title {
          ${FontStyles.text2};
        }
      }

      .header-container {
        margin-top: 18px;

        .item-info {
          margin: 0 0 30px;

          .num {
            margin-bottom: 2px;
          }

          .expires {
            p span {
              white-space: nowrap;
            }

            .start-date {
              margin-bottom: 4px;
              display: inline-block;
            }

            img {
              vertical-align: sub;
            }
          }
        }

        .column-extra {
          margin-top: 16px;
          text-align: center;
        }
      }

      .scheduledOn {
        p {
          ${FontStyles.text7};

          .content-label {
            ${FontStyles.text8};
            margin-right: 3px;

            & + span {
              ${FontStyles.text8};
              margin-right: 3px;
            }
          }
        }
      }
    }

    .body {
      margin: 0 16px;

      &.open {
        max-height: 900px;
      }

      &.close {
        margin-top: -1px;
      }
    }

  }

  .delivery-detail {
    padding: 32px 0 36px;
    border-top: 1px solid ${Colors.gray3};

    li {
      margin-bottom: 28px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .content-label {
    ${FontStyles.text6};
  }
`;

const spStyle2 = CustomMedia.lessThan('tiny')`
  .delivery {
    .header {
      .scheduledOn {
        p {
          ${FontStyles.text9};

          .content-label {
            ${FontStyles.text10};

            & + span {
              ${FontStyles.text8};
            }
          }
        }
      }
    }
  }
`;

export default applyStyles(Delivery)(commonStyle, pcStyle, spStyle, spStyle2);



// WEBPACK FOOTER //
// ./src/components/Mypage/History/components/Delivery.js